module.exports = __webpack_public_path__ + "static/img/credential6.7f6ee06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credential/credential6.jpg
// module id = ThLS
// module chunks = 1